export default {"src":"/_next/static/media/ADBE.e30aa08d.svg","height":18,"width":18};